import { FONT_GENERATOR_TOOL } from '@quicktools/shared-components';

export const VERSION = process.env.NX_APP_VERSION;
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const BASE_URL = process.env.NX_BASE_URL;
export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;
export const TOOL_NAME = FONT_GENERATOR_TOOL.id;
export const RECAPTCHA_SITE_KEY = process.env.NX_RECAPTCHA_SITE_KEY;
export const QUICKTOOLS_API_BASE_URL = process.env.NX_QUICKTOOLS_API_BASE_URL;
